import { render, staticRenderFns } from "./UpdateGroup.vue?vue&type=template&id=75a43e60"
import script from "./UpdateGroup.vue?vue&type=script&lang=js"
export * from "./UpdateGroup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports